import * as Sentry from '@sentry/react'
import axios from 'axios'

import { AuthToken } from '@tribeplatform/gql-client/types'
import { useDomain } from '@tribeplatform/react-components/common'
import { useTribeClient } from '@tribeplatform/react-sdk'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

export const useRefreshToken = () => {
  const { data: network } = useNetwork()
  const { client } = useTribeClient()
  const { subfolder } = useDomain()

  const update = async ({
    refreshToken,
  }: {
    refreshToken: string
  }): Promise<AuthToken | undefined> => {
    try {
      const response = await axios.post<AuthToken>(
        `${subfolder || ''}/api/auth/refresh-token`,
        {
          refreshToken,
          networkDomain: network.domain,
        },
      )

      if (response?.data) {
        client.setToken(response.data.accessToken)

        return response.data
      }
    } catch (e) {
      console.warn('Could not update the refresh token', e)
      Sentry.withScope(scope => {
        // Annotate whether failing operation was query/mutation/subscription
        scope.setTag('operation', 'updateRefreshToken')
        // Log query and variables as extras
        // (make sure to strip out sensitive data!)
        scope.setExtra('refresh-token', refreshToken)
        scope.setExtra('domain', network.domain)
        Sentry.captureException(e)
      })
    }
  }

  return {
    update,
  }
}
